import { useQuery } from "react-query";
import { useAppContext } from "../AppProviders";
import { fetchLegacy360ReportsVisible } from "../api/Legacy360Api";

const STALE_MS = 1000 * 60 * 60 * 24; // 24h

/**
 * 360 Legacy tab: visibility from GET /360/legacy_reports/visible.
 * Runs whenever the host page mounts with a ready API client (Reports / Reports360Legacy).
 * Do not gate on report:page here — many roles reach /reports with other permissions only;
 * the tab and list views still require canManageReports + visible in the UI.
 */
export function useLegacy360ReportsTabVisibility() {
  const { requestApi } = useAppContext();

  return useQuery(
    ["legacy360ReportsVisible"],
    () => fetchLegacy360ReportsVisible(requestApi),
    {
      enabled: Boolean(requestApi),
      staleTime: STALE_MS,
      retry: false,
    }
  );
}
